import { render } from "./ButtonQuiz.vue?vue&type=template&id=1651eac4"
import script from "./ButtonQuiz.vue?vue&type=script&lang=js"
export * from "./ButtonQuiz.vue?vue&type=script&lang=js"
script.render = render

export default script